import axios from "axios";
import { aspNetUrl, newApiBaseUrl } from "../../axiosInstance";

export const GetMosadDetails = () => {
  return axios.get(`${newApiBaseUrl}/nedarim/details`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const Payment = (data) => {
  const headers = {
    Authorization: `bearer ${localStorage.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  return axios.post(`${aspNetUrl}Payment/TranzilaPayCard`, data, { headers });
};

export const SavePaymen = (data) => {
  const headers = {
    Authorization: `bearer ${localStorage.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  return axios.post(`${aspNetUrl}Payment/SavePaymen`, data, { headers });
};

export const GetPaymentPerOrder = (orderId) => {
  return axios.get(`${aspNetUrl}Payment/GetPayment?OrderId=${orderId}`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const GetCards = () => {
  return axios.get(`${newApiBaseUrl}/users/me/cards`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const DeleteCard = (token) => {
  return axios.delete(`${newApiBaseUrl}/users/me/cards/${token}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};
